// extracted by mini-css-extract-plugin
export default {"title":"Works_title__Cp4jo","workscontent":"Works_workscontent__I5KdB","intro":"Works_intro__F+ByO"};